<template>
  <div class="expressAgain">
    <div class="item">
      <p class="title"><span class="check">寄</span><span>请选择寄货地址</span></p>
      <div class="address">
        <div class="line">
          <label for="">
            <span class="info">寄件地址:</span>
            <input id="suggestId" class="address4" type="text" placeholder="小区名、大厦名、街道门牌号" @keyup.enter="getAddress"
                   @blur="getAddress" v-model="info.sendAddress">
            <button class="hisCheck" data-show="true" @click.stop="showAddress(4)">从历史选择</button>
            <div class="history" v-if="show.isShow4">
              <ul>
                <li v-for="(item, index) in historyList" :key="item.id">
                  <img src="../../../assets/images/courier/xuanzhong.png" alt="" v-if="pull.select4 === index"
                       @click.stop="isSelect(index, 4)">
                  <img src="../../../assets/images/courier/meixuan.png" alt="" v-else
                       @click.stop="isSelect(index, 4)">
                  <div class="right">
                    <p>
                      <span>{{item.name}}</span>
                      <span>{{item.mobile}}</span>
                    </p>
                    <p>{{item.addressInfo}}</p>
                  </div>
                </li>
              </ul>
              <div class="btn">
                <span class="yes" @click.stop="sure(4)">确定</span>
              </div>
            </div>
          </label>
          <label for="">
            <span class="info">详细地址:</span>
            <input type="text" placeholder="楼层、门牌号" v-model="info.sendAddressInfo">
          </label>
          <label for="">
            <span class="info">寄件人姓名:</span>
            <input type="text" placeholder="请输入寄件人姓名" v-model="info.sendName">
          </label>
          <label for="">
            <span class="info">寄件人电话:</span>
            <input type="text" placeholder="请输入寄件人电话" v-model="info.sendMobile">
          </label>
          <!--地图-->
          <div id="allmap" class="allmap"></div>
        </div>

      </div>

    </div>
    <div class="item" v-for="(item, index) in ($route.query.type) == 1 ? 1 : 3" :key="index">
      <p class="title"><span class="check collect">收</span><span>请选择收货地址</span></p>
      <div class="address">
        <div class="line">
          <label for="">
            <span class="info">收货地址:</span>
            <input :id="suggestId(index)" :class="'address'+index" type="text" placeholder="小区名、大厦名、街道门牌号" @keyup.enter="getAddress"
                   @blur="getAddress" v-model="info['getAddress'+(index+1)]">
            <button class="hisCheck" data-show="true" @click.stop="showAddress(index)">从历史选择</button>
            <div class="history" v-if="show['isShow'+index]">
              <ul>
                <li v-for="(item, i) in historyList" :key="item.id">
                  <img src="../../../assets/images/courier/xuanzhong.png" alt="" v-if="pull['select'+index] === i"
                       @click.stop="isSelect(i, index)">
                  <img src="../../../assets/images/courier/meixuan.png" alt="" v-else
                       @click.stop="isSelect(i, index)">
                  <div class="right">
                    <p>
                      <span>{{item.name}}</span>
                      <span>{{item.mobile}}</span>
                    </p>
                    <p>{{item.addressInfo}}</p>
                  </div>
                </li>
              </ul>
              <div class="btn">
                <!--<span class="add">新增寄货地址</span>-->
                <span class="yes" @click.stop="sure(index)">确定</span>
              </div>
            </div>
          </label>
          <label for="">
            <span class="info">详细地址:</span>
            <input type="text" placeholder="楼层、门牌号" v-model="info['getAddressInfo'+(index+1)]">
          </label>
          <label for="">
            <span class="info">收件人姓名:</span>
            <input type="text" placeholder="请输入收件人姓名" v-model="info['getName'+(index+1)]">
          </label>
          <label for="">
            <span class="info">收件人电话:</span>
            <input type="text" placeholder="请输入收件人电话" v-model="info['getMobile'+(index+1)]">
          </label>
          <!--地图-->
          <div :id="gernerateId(index)" class="allmap"></div>
        </div>
      </div>
    </div>
    <div class="goodsInfo">
      <label for="">
        <span>物品名称:</span>
        <textarea name="" cols="30" rows="10" placeholder="请输入物品名称" v-model="info.goodsName"></textarea>
      </label>
      <label for="">
        <span>重量:</span>
        <div class="weight">
          <div>
            <input type="tel" placeholder="请输入重量" autocomplete="off" v-model="info.goodsWeight">
            <span>KG</span>
          </div>
        </div>
      </label>
      <label for="" v-if="expressType == 1">
        <span>选择快递:</span>
        <div class="weight" @click.stop="showExpress">
          <div>
            <input type="tel" placeholder="请选择快递" autocomplete="off" v-model="expressTypes" readonly>
            <img src="../../../assets/images/login/xiasanjiao.png" alt="">
          </div>
          <ul class="down" v-if="isExpress">
            <li v-for="(item, index) in expressList" :key="index" @click.stop="checkedItem">{{item}}</li>
          </ul>
        </div>
      </label>
      <label for="" v-if="expressType == 1">
        <span>付款方式:</span>
        <div class="weight" @click.stop="showWay">
          <div>
            <input type="tel" placeholder="请选择付款方式" autocomplete="off" v-model="payMethod">
            <img src="../../../assets/images/login/xiasanjiao.png" alt="">
          </div>
          <ul class="down" v-if="isWay">
            <li @click.stop="wayItem">寄件人付</li>
            <li @click.stop="wayItem">收件人付</li>
          </ul>
        </div>
      </label>
      <label for="">
        <span>时间:</span>
        <div class="">
          <date-time :birthDay="info.getGoodsDate" @time="times" :type="type"/>
        </div>
      </label>
      <div class="vip">
        <img src="../../../assets/images/courier/no_select.png" alt="" @click.stop="handleClick">
        <span>走vip通道</span>
        <router-link :to="{name: 'RichText', query: {code: '001'}}"><img src="../../../assets/images/courier/info.png" alt=""></router-link>
      </div>
      <label for="">
        <span>备注信息:</span>
        <textarea name="" id="" cols="30" rows="10" placeholder="请输入物品名称" v-model="info.description"></textarea>
      </label>
    </div>
    <button class="next" @click.stop="next">下一步</button>
  </div>
</template>

<script>
import DateTime from '../../../components/Time'
import {init} from '../../../utils/map'
import {mobiles} from '../../../utils/phone'
import {reqPastAddress, reqExpress, reqDomesticOrderDetail, reqCityOrderDetail, reqCountCityExpressFee, reqCountStateExpressFee} from '../../../api/index'
import {mapState} from 'vuex'
export default {
  data () {
    return {
      info: {},
      expressTypes: '', // 快递类型
      payMethod: '', // 付款方式
      bool: false,
      // isShow: false, // 历史地址是否显示
      isAdd: false, // 新增地址是否显示
      type: 'datetime', // 时间类型
      historyList: [], // 历史记录列表
      pull: {
        select0: 0,
        select1: 0,
        select2: 0,
        select4: 0
      },
      show: { // 历史地址是否显示
        isShow0: false,
        isShow1: false,
        isShow2: false,
        isShow4: false,
      },
      expressList: '', // 快递列表
      isExpress: false, // 是否显示快递
      isWay: false, // 是否显示支付方式
      reqNum: 0

    }
  },
  mounted () {
    let input = document.getElementsByClassName('input')
    let am = document.getElementsByClassName('allmap')
    for (let i = 0; i < am.length; i++) {
      init('深圳', am[i].id)
      for (let j = 0; j < input.length; j++) {
        tip(input[j].id, input[j], am[i].id, '深圳')
      }
    }
    // 获取快递列表
    reqExpress().then(res => {
      if (res.code === 200) {
        this.expressList = res.data.bussData.svalue.split(/\r\n/)
      }
    })
    // 获取快递信息
    const {id, type} = this.$route.query
    if(type == 1) {
      reqCityOrderDetail(id).then(res => {
        console.log(res)
        if(res.code === 200) {
          this.info = Object.assign({getAddressInfo1: '', getAddressInfo2: '', getAddressInfo3: ''}, res.data.bussData)
        }
      })
    } if(type == 2) {
      reqDomesticOrderDetail(id).then(res => {
        console.log(res)
        if(res.code === 200) {
          this.info = res.data.bussData
        }
      })
    }
  },
  methods: {
    // 显示新增地址
    add () {
      this.isAdd = !this.isAdd
    },
    // 是否现在快递
    showExpress () {
      this.isExpress = !this.isExpress
      this.isWay = false
    },
    // 是否显示付款方式
    showWay () {
      this.isWay = !this.isWay
      this.isExpress = false
    },
    // 选择快递单个
    checkedItem (e) {
      this.expressTypes = e.target.innerText
      this.isExpress = false
    },
    // 选择付款方式单个
    wayItem (e) {
      this.payMethod = e.target.innerText
      this.isWay = false
    },
    // 获取时间
    times (val) {
      this.info.getGoodsDate = val
    },
    // 显示历史地址
    showAddress (i) {
      this.show['isShow' + i] = !this.show['isShow' + i]
      if (!this.reqNum) {
        reqPastAddress({pageIndex: 1, pageSize: 10, type: 2}).then(res => {
          if (res.code === 200) {
            this.historyList = res.data.bussData
            this.reqNum++
          }
        })
      }
    },
    // 关闭历史地址
    closeAddress () {
      this.show.isShow0 = false
      this.show.isShow1 = false
      this.show.isShow2 = false
      this.show.isShow4 = false
    },
    // 下一步
    next () {
      if (!this.info.sendAddress) {
        this.$message({
          message: '寄件地址不能为空',
          type: 'error'
        })
      } else if (!this.info.sendAddressInfo) {
        this.$message({
          message: '寄件详细地址不能为空',
          type: 'error'
        })
      } else if (!this.info.sendName) {
        this.$message({
          message: '寄件人姓名不能为空',
          type: 'error'
        })
      } else if (!this.info.sendMobile) {
        this.$message({
          message: '寄件人电话不能为空',
          type: 'error'
        })
      } else if (!mobiles(this.info.sendMobile)) {
        this.$message({
          message: '寄件人电话不正确',
          type: 'error'
        })
      } else if (!this.info.getAddress1) {
        this.$message({
          message: '收件地址不能为空',
          type: 'error'
        })
      } else if (!this.info.getAddressInfo1) {
        this.$message({
          message: '收件详细地址不能为空',
          type: 'error'
        })
      } else if (!this.info.getName1) {
        this.$message({
          message: '收件人不能为空',
          type: 'error'
        })
      } else if (!this.info.getMobile1) {
        this.$message({
          message: '收件人电话不能为空',
          type: 'error'
        })
      } else if (!mobiles(this.info.getMobile1)) {
        this.$message({
          message: '收件人电话不正确',
          type: 'error'
        })
      } else if (!this.info.goodsName) {
        this.$message({
          message: '物品名称不能为空',
          type: 'error'
        })
      } else if (!this.info.goodsWeight) {
        this.$message({
          message: '物品重量不能为空',
          type: 'error'
        })
      } else if (!this.info.getGoodsDate) {
        this.$message({
          message: '请选择时间',
          type: 'error'
        })
      } else {
        if (this.expressType) {
          if (!this.expressTypes) {
            this.$message({
              message: '请选择快递',
              type: 'error'
            })
          } else if (!this.payMethod) {
            this.$message({
              message: '请选择支付方式',
              type: 'error'
            })
          } else {
            const info = Object.assign(this.info, {expressTypes: this.expressTypes, payMethod: this.payMethod})
            this.$store.dispatch('getExpressInfo', info)
            this.$router.push({name: 'ConfirmOrder'})
          }
        } else {
          this.$store.dispatch('getExpressInfo', this.info)
          this.$router.push({name: 'ConfirmOrder'})
        }
      }
    },
    // 根据地址名称更换地图
    getAddress (e) {
      switch (e.target.id) {
        case 'suggestId':
          this.info.sendAddress = e.target.dataset.address
          break
        case 'suggestId0':
          this.info.getAddress1 = e.target.dataset.address
          break
        case 'suggestId1':
          this.info.getAddress2 = e.target.dataset.address
          break
        case 'suggestId2':
          this.info.getAddress3 = e.target.dataset.address
          break
      }
      let inputId = e.target.id
      let type = e.target.parentNode.nextElementSibling.nextElementSibling.id
      let val = e.target.dataset.address
      if (!val) return false
      init(val, type, inputId, e.target)
    },
    suggestId(i) {
      return 'suggestId' + i
    },
    // 动态填写地图id
    gernerateId (i) {
      return 'allmap' + i
    },
    // 是否选中vip
    handleClick (e) {
      let ev = e.target
      if (this.info.isVip == 1) {
        ev.src = require('../../../assets/images/courier/no_select.png')
        this.info.isVip = 0
      } else {
        ev.src = require('../../../assets/images/courier/selected.png')
        this.info.isVip = 1
      }
    },
    // 是否选中联系人
    isSelect (id, index) {
      this.pull['select' + index] = id
    },
    //  历史地址点击确定
    sure (i) {
      if (i === 4) {
        this.info.sendAddress = this.historyList[this.pull['select' + i]].addressInfo
        document.getElementsByClassName('address4')[0].focus()
      } else {
        this.info['getAddress' + (i + 1)] = this.historyList[this.pull['select' + i]].addressInfo
        document.getElementsByClassName('address' + i)[0].focus()
      }

      this.showAddress(i)
    }
  },
  deactivated() {
    if(this.$route.name == 'ConfirmOrder') {
      // 判断是同城快递还是国内快递，获取服务费
      if (this.expressType) {
        // 国内快递
        let query = `?getGoodsDate=${this.info.getGoodsDate}`
        reqCountStateExpressFee(query).then(res => {
          this.$store.dispatch('getFee', res.data.bussData)
        })
      } else {
        // 同城快递
        const {goodsWeight, getGoodsDate, sendAddress, sendAddressInfo, getAddress1, getAddress2, getAddress3, getAddressInfo1, getAddressInfo2, getAddressInfo3, isVip} = this.info
        let query = `?goodsWeight=${goodsWeight}&getGoodsDate=${getGoodsDate}&sendAddress=${sendAddress}&address1=${getAddress1}&address2=${getAddress2}&address3=${getAddress3}&isVip=${isVip}`
        reqCountCityExpressFee(query).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.$store.dispatch('getFee', res.data.bussData)
          } else if (res.code === 500) {
            this.$router.replace('/courier/cityExpress')
            this.$message({
              message: res.data.errMsg,
              type: 'error'
            })
          }
        })
      }
    }
  },
  computed: {
    ...mapState(['userBaseInfo', 'expressType'])
  },
  components: {
    DateTime
  }
}
</script>

<style scoped lang="less" type="text/less">
.expressAgain{
  padding-top:60px;
  margin-bottom: 100px;
  .title{
    margin-bottom: 24px;
    .check{
      display: inline-block;
      width: 24px;
      height: 24px;
      background: #61aee6;
      color:#fff;
      text-align: center;
      line-height: 24px;
      border-radius: 50%;
      margin-right: 5px;
    }
    .collect{
      background: #FFC168;
    }
  }
  .address{
    label{
      position: relative;
      display: flex;
      margin-bottom: 20px;
      .info{
        display: block;
        width: 75px;
        text-align: right;
        line-height: 36px;
        margin-right: 12px;
      }
      input{
        width: 340px;
        height: 40px;
        border:1px solid #e1e1e1;
        box-sizing: border-box;
        text-indent: 10px;
        &:focus{
          outline: none;
        }
      }
      .hisCheck{
        width:100px;
        height:40px;
        background:#61aee6;
        border:none;
        color:#fff;
        cursor: pointer;
      }
      .history {
        position: absolute;
        left: 87px;
        top: 36px;
        z-index: 999;
        width: 440px;
        padding: 20px;
        box-sizing: border-box;
        border: 1px solid #e1e1e1;
        background: #fff;
        box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.08);
        li {
          display: flex;
          align-items: center;
          margin-top: 25px;
          padding-bottom: 24px;
          border-bottom: 1px solid #e1e1e1;
          &:first-of-type {
            margin-top: 0;
          }

          &:last-of-type {
            padding-bottom: 0;
            border-bottom: none;
          }

          img {
            margin-right: 12px;
            width: 22px;
            height: 22px;
            cursor: pointer;
          }

          .right {
            p {
              margin-bottom: 15px;

              &:last-of-type {
                margin-bottom: 0;
              }
            }
          }
        }

        .btn {
          margin-top: 41px;
          margin-left: 34px;

          span {
            display: inline-block;
            width: 140px;
            height: 46px;
            border-radius: 23px;
            box-sizing: border-box;
            text-align: center;
            line-height: 46px;
            font-size: 16px;
            font-weight: bold;

            &.add {
              margin-right: 60px;
              border: 1px solid #61aee6;
              color: #61aee6;
            }

            &.yes {
              background: #61aee6;
              color: #fff;
              margin-left: 107px;
            }
          }
        }
      }
    }

  }
  .goodsInfo{
    padding:20px 0;
    label{
      display: flex;
      margin-bottom: 20px;
      line-height: 40px;
      span{
        display: block;
        width: 75px;
        text-align: right;
        margin-right: 12px;
      }
      textarea{
        width: 340px;
        height: 100px;
        padding:13px 10px;
        box-sizing: border-box;
        resize:none;
        border:1px solid #e1e1e1;
        &::-webkit-input-placeholder{
          color:#c0c4cc;
        }
      }
      .weight {
        position: relative;
        border: 1px solid #E1E1E1;
        width: 340px;
        height: 40px;
        border-radius: 4px;
        cursor: pointer;
        box-sizing: border-box;
        input {
          width: 295px;
          text-indent: 10px;

          &:focus {
            outline: none;
          }
        }

        span {
          width: 22px;
          display: inline-block;
        }

        .down {
          position: absolute;
          top: 38px;
          width: 100%;
          z-index: 999;
          line-height: 40px;
          text-indent: 10px;
          background: #fff;
          box-shadow: 0px 3px 21px 0px rgba(0, 0, 0, 0.25);

          li {
            border-bottom: 1px dotted #e1e1e1;
            cursor: pointer;
          }
        }

      }
      .down{
        position: relative;
        border:1px solid #E1E1E1;
        width: 340px;
        height: 40px;
        box-sizing: border-box;
        border-radius: 4px;
        cursor: pointer;
        input{
          width: 100%;
          height: 34px;
          text-indent: 10px;
          &:focus{
            outline: none;
          }
          &::-webkit-input-placeholder{
            color:#c0c4cc;
          }
        }
        img{
          position: absolute;
          top: 16px;
          right: 14px;
        }

      }
    }
    .vip{
      margin:0px 0px 17px 87px;
      img{
        vertical-align: middle;
        &:first-of-type{
          cursor: pointer;
        }
      }
      span{
        vertical-align: middle;
        margin:0 4px 0 8px;
        color:#61AEE6;
      }
    }
  }
  .next{
    width: 332px;
    height: 48px;
    margin-left:135px;
    border-radius: 24px;
    background: #61aee6;
    color: #fff;
    border:none;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
  }
  /*地图大小*/
  .allmap {
    width: 511px;
    height: 261px;
    margin-bottom: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/ExpressAgain.vue